angular.module('shared').directive('modalWindow', function() {
  return {
    restrict: 'A',
    link: function($scope, element, attrs) {
      return $scope.isDrawer = attrs.windowClass === 'drawer__wrapper';
    },
    controller: ["$scope", "$timeout", function($scope, $timeout) {
      return $timeout(function() {
        if ($scope.isDrawer) {
          angular.element('body').addClass('modal-open__drawer');
          return $scope.$on('$destroy', function() {
            return angular.element('body').removeClass('modal-open__drawer');
          });
        }
      });
    }]
  };
});
